(function () {
  'use strict';

  // ─── cart snapshot ───────────────────────────────────────────────────────
  // begin_checkout fires on a submit button that navigates away immediately.
  // An async fetch('/cart.js') at click time loses the race with page unload,
  // so we keep a fresh cached cart and push begin_checkout synchronously.
  var cartCache = null;
  function refreshCart() {
    return originalFetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { cartCache = cart; return cart; })
      .catch(function () {});
  }

  // ─── gift detection ──────────────────────────────────────────────────────
  // Adding the main product auto-adds gift products via separate /cart/add
  // fetches. Those must not fire their own add_to_cart events — collect gift
  // variant ids from the DOM so gift-only adds can be skipped.
  function giftVariantIds() {
    var ids = {};
    document.querySelectorAll('.quantity-gift[data-product],cart-drawer-gift[data-id]')
      .forEach(function (el) {
        var id = el.getAttribute('data-product') || el.getAttribute('data-id');
        if (id) ids[String(id)] = true;
      });
    return ids;
  }

  // ─── add_to_cart ───────────────────────────────────────────────────────────
  var originalFetch = window.fetch;
  window.fetch = function (url, options) {
    var result = originalFetch.apply(this, arguments);

    if (typeof url === 'string' && url.includes('/cart/add')) {
      result.then(function (response) {
        response.clone().json().then(function (data) {
          var items = Array.isArray(data.items) ? data.items : [data];
          var gifts = giftVariantIds();
          items = items.filter(function (i) { return !gifts[String(i.variant_id || i.id)]; });
          if (items.length === 0) { refreshCart(); return; } // gift-only add
          var currency =
            (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
            'USD';
          var value = items.reduce(function (sum, i) {
            return sum + i.final_line_price / 100;
          }, 0);

          window.dataLayer = window.dataLayer || [];
          dataLayer.push({ ecommerce: null });
          dataLayer.push({
            event: 'add_to_cart',
            ecommerce: {
              currency: currency,
              value: value,
              items: items.map(function (item) {
                return {
                  item_id: String(item.product_id),
                  item_name: item.product_title,
                  item_variant: item.variant_title || '',
                  price: item.final_price / 100,
                  quantity: item.quantity
                };
              })
            }
          });
          refreshCart();
        }).catch(function () {});
      }).catch(function () {});
    }

    // ─── remove_from_cart ────────────────────────────────────────────────────
    // Shopify cart update: quantity set to 0 = removal
    if (typeof url === 'string' && url.includes('/cart/change')) {
      var body = (options && options.body) ? options.body : null;
      var quantity = null;
      var lineKey = null;

      if (body) {
        try {
          var parsed = typeof body === 'string' ? JSON.parse(body) : body;
          quantity = parsed.quantity;
          lineKey = parsed.id || parsed.line;
        } catch (e) {}
      }

      // Only fire remove event when quantity is set to 0 (item removed)
      if (quantity === 0 && lineKey) {
        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var removedItem = null;
            for (var i = 0; i < cart.items.length; i++) {
              if (String(cart.items[i].key) === String(lineKey) ||
                  String(cart.items[i].id) === String(lineKey)) {
                removedItem = cart.items[i];
                break;
              }
            }
            if (!removedItem) return;

            window.dataLayer = window.dataLayer || [];
            dataLayer.push({ ecommerce: null });
            dataLayer.push({
              event: 'remove_from_cart',
              ecommerce: {
                currency: cart.currency,
                value: removedItem.final_price / 100,
                items: [{
                  item_id: String(removedItem.product_id),
                  item_name: removedItem.product_title,
                  item_variant: removedItem.variant_title || '',
                  price: removedItem.final_price / 100,
                  quantity: removedItem.quantity
                }]
              }
            });
            cartCache = cart;
          }).catch(function () {});
      }
    }

    return result;
  };

  // ─── begin_checkout ────────────────────────────────────────────────────────
  // Push synchronously from the cached cart — the click navigates immediately,
  // so an async fetch here would lose the race with page unload.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('a[href*="/checkout"], button[name="checkout"]');
    if (!btn || !cartCache || !cartCache.items) return;

    window.dataLayer = window.dataLayer || [];
    dataLayer.push({ ecommerce: null });
    dataLayer.push({
      event: 'begin_checkout',
      ecommerce: {
        currency: cartCache.currency,
        value: cartCache.total_price / 100,
        items: cartCache.items.map(function (item) {
          return {
            item_id: String(item.product_id),
            item_name: item.product_title,
            item_variant: item.variant_title || '',
            price: item.final_price / 100,
            quantity: item.quantity
          };
        })
      }
    });
  }, true); // capture: run before the button's own submit handler

  refreshCart(); // prime cache on page load
})();
